import { render, staticRenderFns } from "./ColumnSelectionComponent.vue?vue&type=template&id=5624d838&"
import script from "./ColumnSelectionComponent.vue?vue&type=script&lang=ts&"
export * from "./ColumnSelectionComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/src/services/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5624d838')) {
      api.createRecord('5624d838', component.options)
    } else {
      api.reload('5624d838', component.options)
    }
    module.hot.accept("./ColumnSelectionComponent.vue?vue&type=template&id=5624d838&", function () {
      api.rerender('5624d838', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Table/ColumnSelectionComponent.vue"
export default component.exports